<template>
  <v-dialog v-model="showModel" width="360" hide-overlay :retain-focus="false" scrollable persistent
    content-class="call-contacts">
    <v-card :loading="loading">
      <v-card-title>
        <v-icon>mdi-contacts</v-icon>&nbsp;
        {{ $t('contacts.menuTitle') }}
        <v-spacer></v-spacer>
        <v-btn icon small @click="$emit('show-contacts', false)">
          <v-icon>mdi-close-circle</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text style="padding:0px; max-height: 300px">
        <v-virtual-scroll :items="phoneNumbersFiltered" height="300" :item-height="72">
          <template v-slot:default="{ item, index }">
            <v-list-item @click="dial(item.phoneNumber)" :key="index">
              <v-list-item-avatar>
                <v-img v-if="item.hasImage" :src="item.imageUrl" :alt="item.name"></v-img>
                <v-icon large v-if="!item.hasImage && item.name === parkingName">mdi-car-brake-parking</v-icon>
                <v-icon large v-if="!item.hasImage && item.name === featureCodeName">mdi-code-tags</v-icon>
                <v-img v-if="!item.hasImage && item.name !== parkingName && item.name !== featureCodeName"
                  src="/default_picture_profile.png" :alt="item.name"></v-img>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title><span v-html="formatName(item.name)"></span></v-list-item-title>
                <v-list-item-subtitle>
                  <div v-if="item.name === 'feature_code'">
                    {{ formatLabel(item) }}: <span v-html="formatFeatureCode(item)"></span>
                  </div>
                  <div v-else>
                    {{ formatLabel(item) }}: {{ item.phoneNumber | formatPhoneNum(countryCode) }}
                  </div>
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-virtual-scroll>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'calls-contacts',
  data () {
    return {
      loading: false,
      parkingName: 'parking',
      featureCodeName: 'feature_code'
    }
  },
  props: {
    show: {
      type: Boolean
    },
    pattern: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapGetters({
      phoneNumbers: 'contacts/phoneNumbers/phoneNumbers',
      featureCodesWithTargetExtension: 'contacts/phoneNumbers/featureCodesWithTargetExtension',
      featureCodesWithTargetID: 'contacts/phoneNumbers/featureCodesWithTargetID',
      countryCode: 'countryCode'
    }),
    phoneNumbersFiltered: function () {
      if (this.pattern) {
        return this.phoneNumbers.filter(phoneNumber => {
          return phoneNumber?.phoneNumber?.toLocaleLowerCase().indexOf(this.pattern?.toLocaleLowerCase()) > -1 ||
            phoneNumber?.name?.toLocaleLowerCase().indexOf(this.pattern?.toLocaleLowerCase()) > -1 ||
            phoneNumber?.username?.toLocaleLowerCase().indexOf(this.pattern?.toLocaleLowerCase()) > -1
        })
      } else {
        return this.phoneNumbers
      }
    },
    showModel: {
      get: function () {
        if (this.phoneNumbersFiltered.length === 0) {
          return false
        } else {
          return this.show
        }
      },
      set: function (val) {
        this.$emit('show-contacts', val)
      }
    }
  },
  watch: {
    show (newVal, oldVal) {
      if (newVal && this.phoneNumbers.length === 0) {
        this.loading = true
        this.getPhoneNumbers().then(() => { this.loading = false })
      }
    }
  },
  methods: {
    ...mapActions({
      getPhoneNumbers: 'contacts/phoneNumbers/get'
    }),
    dial: function (num) {
      this.$emit('init-call', num)
      this.$emit('show-contacts', false)
    },
    formatName: function (name) {
      let formattedName = name
      switch (name) {
        case this.parkingName:
          formattedName = this.$t('parking.menuTitle')
          break
        case this.featureCodeName:
          formattedName = this.$t('contacts.featureCode')
          break
      }
      return formattedName
    },
    formatLabel: function (phoneNumber) {
      if (phoneNumber.name === this.featureCodeName) {
        return this.$t(`contacts.featureCodes.${phoneNumber.label}`)
      }
      return phoneNumber.label
    },
    formatFeatureCode (phoneNumber) {
      if (this.featureCodesWithTargetExtension.includes(phoneNumber.label)) {
        return `${phoneNumber.phoneNumber}<b>${this.$t('availableExtensions.extension').toUpperCase()}</b>`
      } else if (this.featureCodesWithTargetID.includes(phoneNumber.label)) {
        return `${phoneNumber.phoneNumber}<b>*ID</b>`
      }
      return phoneNumber.phoneNumber
    }
  }
}
</script>

<style>
.call-contacts {
  position: relative;
  right: 365px
}</style>
